<div class="chart-container" [ngClass]="{'chart-container-high':!filterToggle && !fullScreen, 'chart-container-medium':!filterToggle && fullScreen, 'chart-container-min-medium':filterToggle && fullScreen}">
  <div class="ion-text-center" *ngIf="isToastOpen">
    <h3>{{alert_message}}</h3>
  </div>
  
  <div class="chart-container line-chart" width="100%">
    <canvas id="line-chart" width="100%"></canvas>
  </div>

  <div class="chart-container" [ngStyle]="{'height.px': minChartHeight }" width="100%">
    <canvas id="matrix-chart" width="100%"></canvas>
  </div>
  
</div>